module.exports = __webpack_public_path__ + "img/defaultVoucherIco.20259741.png";